export enum SerpHotelPositionsSortType {
  Recommend = 0,
  PriceUp = 1,
  PriceDown = 2,
  RatingDown = 3,
}

export interface SerpHotelPosition {
  id: number;
  price: number | null;
}

export interface SerpHotelPositionsTracking {
  searchUuid: string | null;
  filteredSearchUuid: string | null;
  sortType: SerpHotelPositionsSortType;
  hotels: readonly SerpHotelPosition[];
  selectedHotelId: number;
}
